import { Injectable } from '@angular/core';
import { InputValidationModel } from '../models/input-validation.model';
@Injectable()
export class HandleHelper {

    /* eslint-disable max-len */
    static readonly TWITTER_PAGE_FORMAT = /http[s]?:\/\/(?:www\.)?(?:twitter|x)\.com\/([A-Za-z0-9_]+)(?:\/|\?|$)|^@?([A-Za-z0-9_]+)$/; // alphanumeric + _
    static readonly INSTAGRAM_PAGE_FORMAT = /http[s]?:\/\/(?:www\.)?instagram\.com\/([A-Za-z0-9\._]*)(?:\/\?.*|\/|\?|$)|^@?([A-Za-z0-9\._]+)$/; // alphanumeric + . _
    static readonly FACEBOOK_PAGE_FORMAT = /http[s]?:\/\/(?:www\.)?facebook\.com\/([A-Za-z0-9\.]*)(?:\/|\?|$)|^@?([A-Za-z0-9\.]+)$/; // alphanumeric + .
    /**
     * Captures channel id or handle value, acceptable characters include alphanumeric, underscores (_), hyphens (-), periods (.)
     */
    static readonly YOUTUBE_CHANNEL_FORMAT = /^(?:http[s]?:\/\/)?(?:www\.)?(?:youtube\.com\/)?(?:c\/|channel\/)?@?([A-Za-z0-9\.\-_]*)(?:\/|\?|$)$/;


    static readonly REDDIT_USER_FORMAT = /(?:http[s]?:\/\/)?(?:www\.)?(?:reddit\.com\/)?user\/([A-Za-z0-9_\-]*)(?:\/|\?|$)|^(?:@|u\/)?([A-Za-z0-9_\-]+)$/; // alphanumeric + _-
    static readonly TIKTOK_USER_FORMAT = /(?:http[s]?:\/\/)?(?:www\.)?(?:tiktok\.com\/)?@?((?!.*\.\.)(?!.*\.$)[^\W][\w.]{2,24})$/; // alphanumeric . _ (but can't end in period)
    static readonly LINKEDIN_PAGE_FORMAT = /http[s]?:\/\/(?:www\.)?linkedin\.com\/in\/([^\/\?\&]*).*/;
    static readonly LINKEDIN_COMPANY_PAGE_FORMAT = /http[s]?:\/\/(?:www\.)?linkedin\.com\/company\/([^\/\?\&]*).*/;
    // Validate LinkedIn URLs or shorthand formats, ensuring they explicitly include prefixes (company/, school/, and showcase/)
    static readonly LINKEDIN_HANDLE_FORMAT = /^(?:http[s]?:\/\/)?(?:www\.)?linkedin\.com\/(company\/[\w\-&.'À-ÿ]+|school\/[\w\-&.'À-ÿ]+|showcase\/[\w\-&.'À-ÿ]+)\/?$|^(company\/|school\/|showcase\/)([\w\-&.'À-ÿ]+)$/; // alphanumeric + . _
    static readonly SNAPCHAT_PAGE_FORMAT = /http[s]?:\/\/(?:www\.)?snapchat\.com\/add\/([^\/\?\&]*).*/;
    static readonly SUB_REDDIT_FORMAT = /(?:http[s]?:\/\/)?(?:www\.)?(?:reddit\.com)?\/r\/([A-Za-z0-9_\-]*)(?:\/|\?|$)|^(?:@|r\/)?([A-Za-z0-9_\-]+)$/; // alphanumeric + _-

    /** optional bluesky profile url path, capture group handle, start with @, allows letters, numbers, dots and hyphens */
    static readonly BLUESKY_HANDLE_FORMAT = /(?:http[s]?:\/\/)?(?:www\.)?(?:bsky\.app\/profile\/)?@?([a-zA-Z0-9.-]+)(?:\/|\?|$)|^@?([a-zA-Z0-9.-]+)$/;

    /* eslint-enable max-len */

    static sanitizeTwitterHandle(input: string): string {
        return input.replace(this.TWITTER_PAGE_FORMAT, (match, ...args) => args[0] || args[1]);
    }

    static sanitizeFacebookHandle(input: string): string {
        return input.replace(this.FACEBOOK_PAGE_FORMAT, (match, ...args) => args[0] || args[1]);
    }

    static sanitizeInstagramHandle(input: string): string {
        return input.replace(this.INSTAGRAM_PAGE_FORMAT, (match, ...args) => args[0] || args[1]);
    }

    static sanitizeYoutubeChannel(input: string): string {
        return input.replace(this.YOUTUBE_CHANNEL_FORMAT, (match, ...args) => args[0] || args[1]);
    }

    static sanitizeRedditUser(input: string): string {
        return input.replace(this.REDDIT_USER_FORMAT, (match, ...args) => args[0] || args[1]);
    }

    static sanitizeSubReddit(input: string): string {
        return input.replace(this.SUB_REDDIT_FORMAT, (match, ...args) => args[0] || args[1]);
    }

    static sanitizeTikTokHandle(input: string): string {
        return input.replace(this.TIKTOK_USER_FORMAT, (match, ...args) => args[0] || args[1]);
    }

    static sanitizeLinkedInPageHandle(input: string): string {
        return input.replace(this.LINKEDIN_PAGE_FORMAT, (match, ...args) => args[0] || args[1]);
    }

    static sanitizeLinkedInCompanyHandle(input: string): string {
        return input.replace(this.LINKEDIN_COMPANY_PAGE_FORMAT, (match, ...args) => args[0] || args[1]);
    }

    static sanitizeSnapchatHandle(input: string): string {
        return input.replace(this.SNAPCHAT_PAGE_FORMAT, (match, ...args) => args[0] || args[1]);
    }

    static sanitizeLinkedInHandle(input: string): string {
        return input.replace(this.LINKEDIN_HANDLE_FORMAT, (match, fullHandle, prefix, identifier) => fullHandle || `${prefix || ''}${identifier || ''}`);
    }

    static sanitizeBlueskyHandle(input: string): string {
        return input.replace(this.BLUESKY_HANDLE_FORMAT, (match, ...args) => args[0] || args[1]);
    }
}


export const twitterValidation = new InputValidationModel({
    requirements: HandleHelper.TWITTER_PAGE_FORMAT,
    exclusions: null,
    errorKey: 'MediaSubscriptions.errors.badHandleFormat'
});

export const facebookValidation = new InputValidationModel({
    requirements: HandleHelper.FACEBOOK_PAGE_FORMAT,
    exclusions: null,
    errorKey: 'MediaSubscriptions.errors.badHandleFormat'
});

export const instaValidation = new InputValidationModel({
    requirements: HandleHelper.INSTAGRAM_PAGE_FORMAT,
    exclusions: null,
    errorKey: 'MediaSubscriptions.errors.badHandleFormat'
});

export const youtubeValidation = new InputValidationModel({
    requirements: HandleHelper.YOUTUBE_CHANNEL_FORMAT,
    exclusions: null,
    errorKey: 'MediaSubscriptions.errors.badHandleFormat'
});

export const redditValidation = new InputValidationModel({
    requirements: HandleHelper.REDDIT_USER_FORMAT,
    exclusions: null,
    errorKey: 'MediaSubscriptions.errors.badHandleFormat'
});

export const subRedditValidation = new InputValidationModel({
    requirements: HandleHelper.SUB_REDDIT_FORMAT,
    exclusions: null,
    errorKey: 'MediaSubscriptions.errors.badHandleFormat'
});

export const tiktokValidation = new InputValidationModel({
    requirements: HandleHelper.TIKTOK_USER_FORMAT,
    exclusions: null,
    errorKey: 'MediaSubscriptions.errors.badHandleFormat'
});

export const linkedinValidation = new InputValidationModel({
    requirements: HandleHelper.LINKEDIN_HANDLE_FORMAT,
    exclusions: null,
    errorKey: 'MediaSubscriptions.errors.badHandleFormat'
});

export const blueskyValidation = new InputValidationModel({
    requirements: HandleHelper.BLUESKY_HANDLE_FORMAT,
    exclusions: null,
    errorKey: 'MediaSubscriptions.errors.badHandleFormat'
});


export const minLengthValidation = new InputValidationModel({
    errorKey: 'Social.agentWidget.error.atLeast2Characters',
    isValid: (input: string): boolean => {
        return input.trim().length > 1;
    }
});

export const mustNotBeOperator = new InputValidationModel({
    errorKey: 'Monitoring.keyWords.keywordsCannotBeBooleanOperators',
    requirements: null,
    exclusions: new RegExp('^(and|or|not)(\\s+[a-z]|$)|(^|[a-z]\\s+)(and|or|not)$', 'i'),
});
